import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClienteService } from '@app/core/service/cliente.service';
import { Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  take
} from 'rxjs/operators';
import { ClientFormsComponent } from '@shared/components/client-forms/client-forms.component';
import { Departamento } from '@core/model/departamento.model';
import { PaisService } from '@core/service/pais.service';
import { DepartamentoService } from '@core/service/departamento.service';
import { OcupaionesService } from '@core/service/ocupaiones.service';
import moment from 'moment';

@Component({
  selector: 'app-huesped-forms',
  templateUrl: './huesped-forms.component.html',
  styles: [
    `
      .icon {
        position: relative;
      }
      .jewel {
        position: absolute;
        display: block;
        top: -8px;
        right: -8px;
        height: 30px;
        width: 33px;
        font-size: 11px;
        font-weight: bold;
        text-align: center;
        line-height: 150% !important;
        color: White;
        -webkit-border-radius: 16px;
        -moz-border-radius: 16px;
        border-radius: 16px;
        overflow: hidden;
      }
    `
  ]
})
export class HuespedFormsComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  @Output() formReady = new EventEmitter<any>();
  subject = new Subject();
  index: any;
  paises: any[] = [];
  departamentos: any[] = [];
  ocupaciones: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    public clienteService: ClienteService,
    private clienteform: ClientFormsComponent,
    public paisService: PaisService,
    public departamentoService: DepartamentoService,
    public ocupaionesService: OcupaionesService
  ) {
    this.formGroup = this.formBuilder.group({
      huespedes: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {
    this.subject
      .pipe(
        map(e => {
          console.log(e);
          return e;
        }),
        filter<string>(ci => ci.length > 2),
        debounceTime(550),
        distinctUntilChanged(),
        switchMap((ci: any) => this.clienteService.getByCI(ci))
      )
      .subscribe(cliente => {
        console.log('cliente', cliente);
        if (Object.entries(cliente).length !== 0) {
          const fecha = moment(cliente.fecha_nac);
          this.huespedes.controls[this.index].patchValue({
            nombres: cliente.nombres,
            apellidos: cliente.apellidos,
            ci: cliente.ci,
            departamento_id: cliente.departamento_id,
            pais: cliente.pais.nombre,
            ocupacion: cliente.ocupacion.nombre,
            cliente_id: cliente.cliente_id,
            celular: cliente.celular,
            estado_civil: cliente.estado_civil,
            fecha_nac: fecha.format('YYYY-MM-DD')
          });
        } else {
          this.huespedes.controls[this.index].patchValue({
            nombres: this.huespedes.controls[this.index].get('nombres').value,
            apellidos: this.huespedes.controls[this.index].get('apellidos')
              .value,
            ci: this.huespedes.controls[this.index].get('ci').value,
            departamento_id: this.huespedes.controls[this.index].get(
              'departamento_id'
            ).value,
            pais: this.huespedes.controls[this.index].get('pais').value,
            celular: this.huespedes.controls[this.index].get('celular').value,
            fecha_nac: this.huespedes.controls[this.index].get('fecha_nac')
              .value,
            ocupacion: this.huespedes.controls[this.index].get('ocupacion')
              .value,
            cliente_id: null,
            estado_civil: this.huespedes.controls[this.index].get(
              'estado_civil'
            ).value
          });
        }
      });
    this.onValueChange();

    this.paisService.getAll().subscribe(res => {
      this.paises = res.data;
      // console.log(res.data);
    });

    this.departamentoService
      .getAll()
      .pipe(take(1))
      .subscribe((res: Departamento[]) => {
        this.departamentos = res;
        this.formGroup.patchValue({
          departamento_id: res[0].departamento_id
        });
        // console.log(this.departamentos);
      });

    this.ocupaionesService
      .getEnabledList()
      .pipe(take(1))
      .subscribe(res => {
        this.ocupaciones = res;
        this.formGroup.patchValue({ ocupacion: res[0].nombre });
        console.log(res);
      });

    this.formGroup.valueChanges.subscribe(res => {
      console.log('huesped cliente', res);
    });
  }

  ngOnDestroy(): void {
    this.subject.unsubscribe();
  }

  newHuesped(): FormGroup {
    return this.formBuilder.group({
      nombres: [
        '',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      apellidos: [
        '',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      ci: [
        '',
        [
          // Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚ[\\s-] ]*'),
          Validators.required,
          Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚ_.+-]*'),
          Validators.minLength(6)
        ]
      ],
      pais: [
        'BOLIVIA',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      departamento_id: [
        '2',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      ocupacion: [
        'SIN OCUPACION',
        [Validators.required, Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]
      ],
      celular: ['', [Validators.pattern('[0-9a-zA-ZñÑáéíóúÁÉÍÓÚx ]*')]],
      fecha_nac: ['', Validators.required],
      cliente_id: '',
      estado_civil: ''
    });
  }

  get huespedes(): FormArray {
    return this.formGroup.get('huespedes') as FormArray;
  }

  removeHuesped(i: number) {
    this.huespedes.removeAt(i);
  }

  addHuesped() {
    this.huespedes.push(this.newHuesped());
    // console.log('fsdfsfdsdf',this.formGroup);
  }

  onValueChange(event?: any) {
    console.log(event);
    this.formReady.emit({ name: 'huespedes', form: this.huespedes });
  }

  ciFind(index: any) {
    this.index = index;
    this.subject.next(this.huespedes.controls[index].get('ci').value);
  }

  formInitializedClient(data: any, i: number) {
    // this.formGroup.setControl(data.name, data.form);
    // this.huespedes.push(new FormGroup(data.form));
    // console.log(data, i);
    // this.huespedes.push()
    // this.huespedes.insert(i, data.form);

    this.huespedes.setControl(i, data.form);

    // form
    // console.log(this.huespedes.at(i));
    // console.log(this.formGroup.value);
    // console.log();
  }
}
